<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-chip-grid #elementsList>
    @for (element of selectedElements; track element.id) {
      <la-team-chip-editable [color]="element.color" [removable]="true" (remove)="remove(element)">
        {{ element.name }}
      </la-team-chip-editable>
    }

    @if (canAddTeams) {
      <input
        #elementsInput
        placeholder="Assign to team"
        [formControl]="inputControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="elementsList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)"
      />
    }
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event)">
    @for (element of autocompleteElements$ | async; track element.id) {
      <mat-option [value]="element">
        {{ element.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
